import {memo} from 'react';
import {Card, CardBody} from "@material-tailwind/react";

const DashboardCardSkeleton = () => {
    return (
        <Card className="bg-white dark:bg-blue-gray-900 animate-pulse">
            <CardBody className="p-4 md:p-5 flex items-start gap-3 md:gap-4">
                <span className="shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-gray-200 dark:bg-gray-800"/>
                <div className="flex-1">
                    <div className="h-3 w-20 rounded-full bg-gray-200 dark:bg-gray-800"/>
                    <div className="mt-3 h-5 w-24 rounded-full bg-gray-300 dark:bg-gray-700"/>
                </div>
            </CardBody>
        </Card>
    );
}

export default memo(DashboardCardSkeleton);
